/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021-2024 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2026 (c) Nico Brandt, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import Machine from './Machine';
import { Dispatch } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import MachinesActions from './MachinesActions';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { IMachine } from '@umati/dashboard-types';
import { Button } from 'react-bootstrap';
import { AllowedRoles } from 'Contexts/Auth';

interface MachineListProps {
  machines?: IMachine[];
  dispatch?: Function;
  machinesRequested?: boolean;
}

interface MachineListState {
  loaded: boolean;
}

class MachineList extends Component<MachineListProps, MachineListState> {
  constructor(props: MachineListProps) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    if (this.props.dispatch) {
      this.props.dispatch(MachinesActions.QueryMachines());
    }
  }

  resetShortIds() {
    if (this.props.dispatch) {
      this.props.dispatch(MachinesActions.ResetShortIds());
    }
  }

  render() {
    const machines = [...(this.props.machines || [])].sort((a, b) => a.Id - b.Id);

    return (
      <div>
        <div>{this.props.machinesRequested && 'Machines requested...'} &nbsp;</div>
        <Container>
          <AllowedRoles roles={['SuperAdmin', 'Admin']}>
            <Button onClick={() => this.resetShortIds()} variant="danger">
              Reset ShortIds
            </Button>
          </AllowedRoles>
          <Row>
            {machines.map((machine) => (
              <Col key={machine.Id} md={6}>
                <Machine {...machine}></Machine>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (
  state: { machines: { machinesRequested: any; machines: any } },
  ownProps: MachineListProps,
) => {
  return {
    ...ownProps,
    machinesRequested: state.machines.machinesRequested,
    machines: state.machines.machines,
  };
};

export default connect(mapStateToProps)(MachineList);
